// extracted by mini-css-extract-plugin
export default {"animationContainer":"LoaderAnimation_animationContainer__1MuvY"};